import React, { useState, useEffect } from 'react';
import firebase from './firebase.js';
import Btn from './button.png';

function Component1() {
  const [numUsers] = useState(6); // Number of users
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const db = firebase.database();

  useEffect(() => {
    // Initialize statuses on component mount
    db.ref('statuses').once('value')
      .then(snapshot => {
        const statuses = snapshot.val() || Array(numUsers).fill(false);
        db.ref('statuses').set(statuses); // Ensure statuses are initialized in Firebase
      })
      .catch(error => console.error('Error fetching statuses:', error));
  }, [db, numUsers]);

  const toggleFullScreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen().catch(err => {
        console.log(`Error attempting to enable full-screen mode: ${err.message}`);
      });
      setIsFullScreen(true);
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
        setIsFullScreen(false);
      }
    }
  };

  const handleSetStatus = () => {
    if (!isButtonDisabled) {
      db.ref('statuses').once('value')
        .then(snapshot => {
          const statuses = snapshot.val() || Array(numUsers).fill(false);
          const currentIndex = statuses.findIndex(status => status === false);

          if (currentIndex >= 0 && currentIndex < numUsers) {
            statuses[currentIndex] = true;
            db.ref('statuses').set(statuses)
              .then(() => {
                // Check if all lamps are lit (no more false values)
                const allLampsLit = statuses.every(status => status === true);
                
                if (allLampsLit) {
                  // Show Reset button after all lamps are lit
                  localStorage.setItem('showResetButton', 'true');
                }

                // Disable the button for 2 seconds
                setIsButtonDisabled(true);
                setTimeout(() => {
                  setIsButtonDisabled(false);
                }, 2000);
              })
              .catch(error => console.error('Error updating status:', error));
          } else {
            // If no available slot, disable button anyway
            setIsButtonDisabled(true);
            setTimeout(() => {
              setIsButtonDisabled(false);
            }, 2000);
          }
        })
        .catch(error => console.error('Error fetching statuses:', error));
    }
  };

  const handleReset = () => {
    db.ref('statuses').set(Array(numUsers).fill(false))
      .then(() => {
        localStorage.removeItem('showResetButton');
        window.location.reload(); // Reload to reset Component2 images
      })
      .catch(error => console.error('Error resetting statuses:', error));
  };

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-[#026433] relative">
      {/* Full Screen Button */}
      <button 
        onClick={toggleFullScreen}
        className="absolute top-4 right-4 bg-white bg-opacity-20 hover:bg-opacity-30 text-white font-bold py-2 px-4 rounded z-10 transition-all duration-200"
        title={isFullScreen ? "Exit Full Screen" : "Enter Full Screen"}
      >
        {isFullScreen ? '⎗' : '⛶'}
      </button>

      <button 
        onClick={handleSetStatus} 
        className={`font-bold w-60 py-2 px-4 rounded ${isButtonDisabled ? 'opacity-50 cursor-not-allowed' : ''}`}
        disabled={isButtonDisabled}
      >
        <img src={Btn} alt="Button" />
      </button>
      {localStorage.getItem('showResetButton') === 'true' && (
        <button 
          onClick={handleReset} 
          className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded mt-4"
        >
          Reset
        </button>
      )}
    </div>
  );
}

export default Component1;